import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import { useEffect } from 'react';

export default function useReset() {
  const callbacks = useApplicationCallbacks();
  useEffect(() => callbacks.resetWishData, []);
}
